export default __webpack_public_path__ + "static/thenomadguidewhodecodesthesahara-3da82053ade1c54d04e36069e9ad9bb5.jpg";